import {
  type ActionButtonAttributes,
  ACTION_BUTTON_NODE_NAME,
} from '../extensions/action-button/index';

import type { Editor } from '@tiptap/react';

type JSONContent = {
  type?: string;
  attrs?: ActionButtonAttributes;
  content?: JSONContent[];
};

function isActionButtonAttrs(attrs: ActionButtonAttributes) {
  return (
    typeof attrs.buttonId === 'string' &&
    typeof attrs.value === 'string' &&
    typeof attrs.link === 'string' &&
    typeof attrs.backgroundColor === 'string' &&
    typeof attrs.textColor === 'string' &&
    typeof attrs.borderRadius === 'string' &&
    typeof attrs.fullWidth === 'boolean' &&
    (attrs.alignment === 'left' ||
      attrs.alignment === 'center' ||
      attrs.alignment === 'right')
  );
}

function walk(node: JSONContent, acc: ActionButtonAttributes[]) {
  if (
    node.type === ACTION_BUTTON_NODE_NAME &&
    node.attrs &&
    isActionButtonAttrs(node.attrs)
  ) {
    acc.push(node.attrs);
  }

  (node.content ?? []).forEach(child => walk(child, acc));
}

/**
 * Extract all Action Button nodes from the editor document as a flat array.
 * This is the easiest way to keep an external `buttons[]` array in sync with editor content.
 */
export function getActionButtonsFromEditor(
  editor: Editor,
): ActionButtonAttributes[] {
  const json = editor.getJSON() as JSONContent;
  const result: ActionButtonAttributes[] = [];
  walk(json, result);
  return result;
}
